import { render } from "./OverlayLoading.vue?vue&type=template&id=15042452"
import script from "./OverlayLoading.vue?vue&type=script&lang=js"
export * from "./OverlayLoading.vue?vue&type=script&lang=js"

import "./OverlayLoading.vue?vue&type=style&index=0&id=15042452&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__